import { forwardRef } from 'react'

const Radio = forwardRef(
  (
    {
      variant,
      className = '',
      radioClassName = '',
      wrapperClassName = '',
      labelClassName = '',
      label,
      ...props
    },
    ref = null
  ) => {
    if (variant === 'secondary') {
      return (
        <label className={`flex items-center ${wrapperClassName}`}>
          <input
            type="radio"
            className={`appearance-none p-0 m-0 b-0 ${className} peer`}
            {...props}
            ref={ref}
          />

          <span
            className={`w-5 h-5 relative border-[#A1A1AA] border-[1px] bg-[#F4F4F5] rounded-full transition-all duration-200 ease peer-checked:bg-white peer-checked:border-[4px] peer-checked:border-[#F79009] ${radioClassName}`}
          />

          {!!label && <span className={`!ml-[12px] ${labelClassName}`}>{label}</span>}
        </label>
      )
    }

    return (
      <label className={`flex items-center ${wrapperClassName}`}>
        <input
          type="radio"
          className={`appearance-none p-0 m-0 b-0 ${className} peer`}
          {...props}
          ref={ref}
        />

        <span
          className={`w-5 h-5 relative border !border-primary-75 border-3 rounded-full peer-checked:text-red-900 inline-flex items-center justify-center after:w-2.5 after:h-2.5 after:bg-primary-75 after:rounded-full after:hidden peer-checked:after:block ${radioClassName}`}
        />

        {!!label && <span className={`!ml-2 ${labelClassName}`}>{label}</span>}
      </label>
    )
  }
)

export default Radio
